import { createSvgIcon } from '@material-ui/core';

export const UploadIcon = createSvgIcon(
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 44H32V30.5H41L24.5 14L8 30.5H17V44ZM41 5V9.5H8V5H41Z"
      fill="currentColor"
    />
  </svg>,
  'UploadIcon',
);
